import React, { useContext, useState } from 'react';
import { xs_isMobile } from '../..';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration, getCurrencySymbol, getLocaleDotRound, getValidAmountString, getAmountInCent } from '../../data/utils';
import Keypad from './Keypad';

function AmountBetslipForm(props) {
	const betslipContext = useContext(BetslipContext);

	const conf = getConfiguration();
	const betslipData = betslipContext.getBetslipData();
	const mult = conf.cs.m;
	const nDec = conf.cs.nd;
	const charDecimalBrowser = getLocaleDotRound().round;
    const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    
    const [showKeypad, setShowKeypad] = useState(false);

    function toggleKeypad(e) {
        const newValue = !showKeypad;
        setShowKeypad(newValue);
        betslipContext.setKeypadShown(newValue);
    }

    function closeKeypad() {
        setShowKeypad(false);
        betslipContext.setKeypadShown(false);
    }
    
    const isEventForm = props.isEventForm;
    let event = null;
    if (isEventForm) {
    	const pal = props.pal;
    	const avv = props.avv;
    	if (coupon != null) {
    		for (var key in coupon.selections) {
    			var selection = coupon.selections[key];
    			if (selection.pal === pal && selection.avv === avv) {
    				event = selection;
    			}
    		}
    	}
    }
    
   // the amount we use to make calcs
   let amount = isEventForm && event ? event.bets[0].amount : coupon.amountMulti;
   // the amount printed in the text field
   let printableAmount =  coupon.printableAmountMulti;
   if(isEventForm && event != null){
	   const scomSogei = props.scomSogei;
	   const handicap = props.handicap;
	   const draw = props.draw;
	   for(let km in event.bets){
		   const bet = event.bets[km];
   		   if(bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw == draw){
   			   printableAmount = bet.printableAmount;
   		   }
	   }
   }

   function setAmount(settedAmount) {
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
	   settedAmount = getValidAmountString(settedAmount, nDec);
	   // putting the "browser decimal dot" instead of the "." for the float type
	   let fieldTextValue = settedAmount;
	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
	   let amountCentToSet = amount; // last valid amount
	   
	   // if is number, I calculate the new amount and I keep it into the field value. 
	   // If not, I keep the field but I use the last valid amount for the calcs
	   if (!isNaN(settedAmount) && settedAmount.length > 0) {
		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
	   }
	   
	   if (isEventForm) {
			if (event != null) {
		    	const scomSogei = props.scomSogei;
		    	const handicap = props.handicap;
		    	const draw = props.draw;
		    	for (let km in event.bets) {
		    		const bet = event.bets[km];
		    		if(bet.scomSogei == scomSogei && bet.handicap == handicap && bet.draw === draw) {
						bet.amount = amountCentToSet;
						bet.printableAmount = fieldTextValue;
		    		}
		    	}
			}
		} else {
			coupon.amountMulti = amountCentToSet;
			coupon.printableAmountMulti = fieldTextValue;
		}
	   
		betslipContext.setBetslipData(betslipData, true);
	}

    const currency = getCurrencySymbol(conf.cs.ct);

    return (
        <>
            {xs_isMobile ?
                <div className="calculatorInput" onClick={toggleKeypad}>{printableAmount} {currency}</div>
                :
                <div className="calculatorInput__container">
                    <input className="calculatorInput" onChange={e => setAmount(`${e.target.value}`)} value={printableAmount} />
                    <div className="calculatorInput__currency">{currency}</div>
                </div>
            }
            {showKeypad &&
                <Keypad amount={printableAmount}
                        currency={currency}
                        decimalsEnabled={nDec > 0}
                        decimalSeparator={charDecimalBrowser}
                        setAmount={setAmount}
                        close={closeKeypad} />
            }
        </>
    );
}

export default AmountBetslipForm;
